export default "<app-online-appointment-list></app-online-appointment-list>\r\n";